import React from 'react';
import { BrowserRouter as Router, Route, Routes, } from 'react-router-dom';
import NewsDashboardPage from './pages/NewsDashboardPage';
import LandingPage from './pages/LandingPage';
import ArchivedNewsPage from './pages/ArchivedNewsPage';
import {ToastContainer} from "react-toastify";
import NewsHighlightsPage from './pages/NewsHighlightsPage';


const App = () => {
  return (
      <div>
        <ToastContainer position="bottom-center" autoClose={3000} />
        <Router>
          <Routes>
              <Route path='/' element={<LandingPage />} />
              <Route exact path="/news_highlights" element={<NewsHighlightsPage />} />
              <Route exact path="/news_dash" element={<NewsDashboardPage />} />
              <Route exact path="/archived_news" element={<ArchivedNewsPage />} />
          </Routes>
        </Router>
      </div>
  );
};

export default App;